/**
 *
 * Maps
 *
 * Maps constants
 *
 * @author     K. van den Broek <k.vandenbroek@uselab.com>
 * @copyright  Uselab Amsterdam
 *
 */

import guid from 'shared/helpers/guid';

const API_KEY = process.env.VUE_APP_MAPS_API_KEY || '';

const DEFAULT_MAP_TYPE_ID = 'HYBRID';

const DEFAULT_MAP_STYLES = [
  {
    featureType: 'landscape',
    elementType: 'geometry.fill',
    stylers: [{ color: '#f9f3e2' }]
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [{ color: '#ffffff' }, { visibility: 'off' }]
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#cdc7a4' }, { visibility: 'off' }]
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#8c8b83' }, { visibility: 'off' }]
  },
  {
    featureType: 'road',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#ffffff' }, { visibility: 'off' }]
  },
  {
    featureType: 'road', /* direction arrows */
    elementType: 'labels.icon',
    stylers: [{ color: '#ffffff' }, { visibility: 'off' }]
  },
  {
    featureType: 'poi',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [{ color: '#aee377' }, { visibility: 'off' }]
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [{ color: '#a0d6f1' }]
  },
  {
    featureType: 'administrative',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'landscape',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'transit',
    stylers: [{ visibility: 'off' }]
  }
];

const DEFAULT_CENTER = {
  lat: 52.3416087,
  lng: 4.5612467
}

const USER_MARKER_GUID = guid();

export default {
  API_KEY,
  DEFAULT_MAP_TYPE_ID,
  DEFAULT_MAP_STYLES,
  DEFAULT_CENTER,
  USER_MARKER_GUID
}
